import { render, staticRenderFns } from "./EditIssueStatus.vue?vue&type=template&id=03367d0d&"
import script from "./EditIssueStatus.vue?vue&type=script&lang=js&"
export * from "./EditIssueStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03367d0d')) {
      api.createRecord('03367d0d', component.options)
    } else {
      api.reload('03367d0d', component.options)
    }
    module.hot.accept("./EditIssueStatus.vue?vue&type=template&id=03367d0d&", function () {
      api.rerender('03367d0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/User/EditIssueStatus.vue"
export default component.exports